<template>
  <div
    class="cell"
    :class="cssClass"
    @click="focusCell(true)"
    :title="textValue"
  >
    <span class="text" v-if="!isEditable">
      <span class="group-checkboxs" v-if="type == 'group-checkbox'">
        <el-checkbox
          :checked="!!value[column + '_phone']"
          v-model="value[column + '_phone']"
          disabled
        ></el-checkbox>
        <el-checkbox
          :checked="!!value[column + '_email']"
          v-model="value[column + '_email']"
          disabled
        ></el-checkbox>
        <el-checkbox
          :checked="!!value[column + '_linkedin']"
          v-model="value[column + '_linkedin']"
          disabled
        ></el-checkbox>
      </span>
      <template v-else>
        {{ textValue }}
      </template>
    </span>
    <div v-else>
      <input
        v-if="type == 'text'"
        type="text"
        v-model="idValue"
        class="input"
        @blur="fireBlur(value)"
        @focus="fireFocus"
        @keyup.enter="fireSaved(value)"
        @keyup.up="fireUpKey"
        @keyup.down="fireDownKey"
        autocomplete="no"
        ref="cellselected"
      />
      <el-select
        v-else-if="type == 'list'"
        v-model="idValue"
        placeholder=" "
        loading-text=" "
        no-match-text=" "
        no-data-text=" "
        clearable
        filterable
        value-key="value"
        :allow-create="allowCreate"
        :remote="isRemote"
        :remote-method="callRemoteMethod"
        @focus="focusSelect"
        @blur="blurSelect"
        ref="cellselected"
      >
        <el-option
          v-for="item in listOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <div v-else-if="type == 'group-checkbox'" class="group-checkboxs">
        <el-checkbox
          :checked="!!value[column + '_phone']"
          v-model="value[column + '_phone']"
        ></el-checkbox>
        <el-checkbox
          :checked="!!value[column + '_email']"
          v-model="value[column + '_email']"
        ></el-checkbox>
        <el-checkbox
          :checked="!!value[column + '_linkedin']"
          v-model="value[column + '_linkedin']"
        ></el-checkbox>
      </div>
      <el-date-picker
        v-else-if="type == 'date'"
        v-model="idValue"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder=""
        prefix-icon="is-hidden"
        ref="cellselected"
      >
      </el-date-picker>
      <el-date-picker
        v-else-if="type == 'datetime'"
        v-model="idValue"
        type="datetime"
        value-format="yyyy-MM-dd HH:mm"
        placeholder=""
        prefix-icon="is-hidden"
        ref="cellselected"
      >
      </el-date-picker>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'TableCell',
  props: {
    value: {
      type: [Number, String, Object],
      default: null,
      required: true
    },
    cssClass: {
      type: String,
      default: ''
    },
    column: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    list: {
      type: [Array, String],
      default: () => {
        return [];
      }
    },
    selectedColumn: {
      type: String,
      default: ''
    },
    allowCreate: {
      type: Boolean,
      default: false
    },
    remoteMethod: {
      type: Function,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      options: []
    };
  },
  mounted() {
    if (this.isRemote && this.value && this.value[this.column] != '') {
      this.options = [
        this.$store.getters[this.list + '/byId'](this.value[this.column])
      ];
    }
  },
  computed: {
    isEditable() {
      if (this.value.isNew) return true;
      else if (this.readonly) return false;
      else if (this.value.isEdit) return true;
      else return false;
    },
    isRemote() {
      return this.remoteMethod ? true : false;
    },
    listOptions() {
      console.log('calculate list options');
      if (typeof this.list == 'string') {
        if (this.isRemote) {
          return this.options;
        } else return this.$store.getters[this.list + '/list'];
      } else {
        return this.list;
      }
    },
    listValues() {
      if (typeof this.list == 'string') {
        return this.$store.getters[this.list + '/list'];
      } else {
        return this.list;
      }
    },
    textValue() {
      if (this.type == 'list') {
        const arr = this.listValues.filter(item => {
          if (item.value == this.idValue) return item;
        });
        if (arr.length > 0) return arr[0].label;
        else return '';
      } else {
        return this.idValue;
      }
    },
    idValue: {
      get() {
        if (this.value) return this.value[this.column];
        else return '';
      },
      set(newValue) {
        if (this.value) this.value[this.column] = newValue;
      }
    }
  },
  watch: {
    idValue() {
      if (this.isRemote) {
        this.options = [];
        this.addMySelfValueToOptions();
      }
    },
    isEditable(newValue, oldValue) {
      console.log(newValue, oldValue);
      if (newValue) {
        if (this.selectedColumn == this.column) {
          this.focusCell(false);
        }
      }
    }
  },
  methods: {
    handleTab(event) {
      if (event.key == 'Tab') {
        this.$refs.cellselected.selectOption();
      }
    },
    blurSelect() {
      this.$refs.cellselected.$refs.reference.$refs.input.removeEventListener(
        'keydown',
        this.handleTab
      );
    },
    focusSelect() {
      this.$refs.cellselected.$refs.reference.$refs.input.addEventListener(
        'keydown',
        this.handleTab
      );
    },
    focusCell(force) {
      if (force) this.fireFocus();
      console.log('focus cell');
      setTimeout(() => {
        if (this.$refs.cellselected) {
          this.$refs.cellselected.focus();
        }
      }, 500);
    },
    callRemoteMethod(query) {
      if (query !== '' && query.trim().length > 2) {
        setTimeout(() => {
          this.options = this.remoteMethod(query);
          this.addMySelfValueToOptions();
        }, 200);
      } else {
        this.options = [];
        this.addMySelfValueToOptions();
      }

      console.log('callRemoteMethod ', this.options);
    },
    addMySelfValueToOptions() {
      console.log('addMySelfValueToOptions');
      const tmp = _.find(this.options, ['id', this.value[this.column]]);
      if (!tmp) {
        const tmp2 = this.$store.getters[this.list + '/byId'](
          this.value[this.column]
        );
        if (tmp2) {
          this.options.push(tmp2);
        }
      }
    },
    fireBlur(item) {
      this.$emit('blur', item);
    },
    fireFocus() {
      console.log('focus ', this.column);
      this.$emit('focus', this.column);
    },
    fireSaved(item) {
      this.$emit('saved', item);
    },
    fireUpKey() {
      console.log('up');
      this.$emit('up');
    },
    fireDownKey() {
      console.log('down');
      this.$emit('down');
    }
  }
};
</script>

<style lang="scss">
.cell {
  .text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
    user-select: none;
  }

  .input {
    border: none;
    background: transparent;
    padding: 0;
    font-size: 14px;
  }

  .el-select {
    input {
      background: transparent;
      border: none;
      padding: 0;
    }
  }

  .group-checkboxs {
    display: flex;
    justify-content: center;

    .el-checkbox {
      margin: 0 5px;

      &:hover {
        cursor: auto !important;
      }

      .el-checkbox__input {
        &.is-focus {
          .el-checkbox__inner {
            -webkit-box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);
            -moz-box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);
            box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);
          }
        }

        .el-checkbox__inner {
          width: 16px;
          height: 16px;
          border: solid 0px #000000;
          background: #ffffff;
          cursor: auto !important;

          &:after {
            border-color: #000000;
            height: 10px;
            left: 5px;
            cursor: auto !important;
          }
        }
        &:hover {
          cursor: auto !important;
        }
      }

      &.is-disabled {
        opacity: 0.3;
      }
    }
  }

  .el-date-editor {
    width: 100%;
    input {
      width: 100%;
      padding: 0;
      background: transparent;
      border: none;
    }
  }
}
</style>
